export default __webpack_public_path__ + "static/media/Equipo.beeeaef7.svg";